import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    kpi: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1),
        minWidth: 160,
        justifyContent: 'center'
    },
    bubble: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color: '#fff'
    },
    label: {
        display: 'block',
        color: theme.palette.secondary.dark,
        marginBottom: theme.spacing(0.5)
    },
    value: {fontWeight: 700, lineHeight: 1},
    secondary: {marginTop: theme.spacing(0.5)}
}));

export default function CardMetrica({titulo, valor, valorSecundario, bubbleClass, valueClass, Icon}) {
    const classes = useStyles();
    return (
        <div className={classes.kpi}>
            <Paper className={clsx(classes.bubble, bubbleClass)} elevation={4}>
                <Icon style={{fontSize: 26}}/>
            </Paper>
            <div>
                <Typography variant='caption' className={classes.label}>{titulo}</Typography>
                <Typography variant='h4' className={clsx(classes.value, valueClass)}>{valor}</Typography>
                {valorSecundario && (
                    <Typography variant='body2' color='textSecondary' className={classes.secondary}>
                        {valorSecundario}
                    </Typography>
                )}
            </div>
        </div>
    );
}

CardMetrica.propTypes = {
    titulo: PropTypes.string.isRequired,
    valor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    valorSecundario: PropTypes.string,
    bubbleClass: PropTypes.string.isRequired,
    valueClass: PropTypes.string.isRequired,
    Icon: PropTypes.elementType.isRequired
};
